import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const selectorWrapStyle = {
  display: 'inline-flex',
  gap: 10,
  padding: 10,
  borderRadius: 12,
  border: '1px solid #F0DFDB',
  background: '#FFF9F7',
  boxShadow: '0 8px 16px rgba(192, 54, 38, 0.05)',
};

const optionStyle = (active) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  padding: '10px 14px',
  borderRadius: 10,
  border: active ? '1px solid #C03626' : '1px solid #E5C7C0',
  background: active ? '#FFF4F1' : '#ffffff',
  color: active ? '#C03626' : '#2D1F1B',
  fontWeight: active ? 700 : 600,
  textDecoration: 'none',
  minWidth: 140,
  boxShadow: active ? '0 10px 18px rgba(192, 54, 38, 0.08)' : '0 4px 10px rgba(0,0,0,0.04)',
  transition: 'all 0.2s ease',
});

const AgentSelector = () => {
  const location = useLocation();
  const current = location.pathname.startsWith('/agents/email') ? 'email' : 'plc';

  const options = [
    { key: 'plc', label: 'PLC Agent', path: '/agents' },
    { key: 'email', label: 'Email agent', path: '/agents/email' },
  ];

  return (
    <div style={selectorWrapStyle}>
      {options.map((opt) => {
        const active = current === opt.key;
        return (
          <Link key={opt.key} to={opt.path} style={optionStyle(active)}>
            {opt.label}
          </Link>
        );
      })}
    </div>
  );
};

export default AgentSelector;
